// The one coin mark for the whole app (settings, portfolio, signals, news,
// alerts, social, sheets, the Orca bar…): the official logo from
// src/assets/coins (same images the landing uses), bundled locally. A coin
// without a logo file gets one neutral fallback — never a different look per page.
const FILES = import.meta.glob<string>('../../assets/coins/*.png', { eager: true, import: 'default' });
const LOGO: Record<string, string> = Object.fromEntries(
  Object.entries(FILES).map(([path, url]) => [path.split('/').pop()!.replace('.png', '').toUpperCase(), url]),
);
/** logos drawn light-on-transparent need a backing to stay visible on light surfaces */
const BACKING: Record<string, string> = { LINK: '#fff' };
/** networks shown in transfers that are not coins of their own */
const NETWORK_ART: Record<string, string> = {
  BASE: '<circle cx="16" cy="16" r="16" fill="#0052FF"/><path fill="#fff" d="M15.98 25.5a9.5 9.5 0 1 0-9.46-10.36h12.55v1.72H6.52A9.5 9.5 0 0 0 15.98 25.5z"/>',
};

export const hasCoinLogo = (symbol: string) => !!LOGO[symbol] || !!NETWORK_ART[symbol];

export function CoinIcon({ symbol }: { symbol: string }) {
  const url = LOGO[symbol];
  if (url) {
    return (
      <span className="cdot cico" data-coin={symbol}>
        <img src={url} alt="" draggable={false} style={BACKING[symbol] ? { background: BACKING[symbol] } : undefined} />
      </span>
    );
  }
  const art = NETWORK_ART[symbol];
  if (art) return <span className="cdot cico" data-coin={symbol}><svg viewBox="0 0 32 32" aria-hidden="true" dangerouslySetInnerHTML={{ __html: art }} /></span>;
  return <span className="cdot cfb" data-coin={symbol} aria-hidden="true">{symbol.slice(0, 3)}</span>;
}
